module.exports = __webpack_public_path__ + "img/shangzhang.58f6ce35.png";